/* eslint-disable react/no-array-index-key */
import UnfulfilledTitle from '@assets/unfulfilled-title.svg';
import {
  PageTitle,
  BottomButtons,
  Panel, CheckBoxItem, TrackingFormItem, MessageTips,
} from '@components';

import { useState } from 'react';
import { Form, message } from 'antd';
import { trackNumberTest } from '@/utils';
import { useNavigate } from 'react-router-dom';
// import classes from '../choose/index.module.css';
import { useSelector } from 'react-redux';
import { fulfilledTracking } from '@api';
// import { getPackageData } from '@hooks';
import classes from './index.module.css';

export const Unfulfilled = () => {
  const [selected, setSelected] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [form] = Form.useForm();

  const { unFulfilledItems, policyId } = useSelector((store) => store.claim);
  // const dispatch = useDispatch();
  const navigate = useNavigate();

  const onValuesChange = (value, values, items) => {
    let flag = false;
    Object.values(values).forEach((item) => {
      if (!item) {
        flag = true;
      }
    });
    if (!trackNumberTest(values.trackingNumber)) {
      flag = true;
    }
    if (items?.length === 0) {
      flag = true;
    }
    if (flag !== disabled) {
      setDisabled(flag);
    }
  };

  const handleChange = (event) => {
    // console.log(packageIndex, index, item);
    const { checked, value } = event.target || {};
    const tempSelected = [...selected];
    if (!checked) {
      const index = selected.findIndex((item) => item === value);
      if (index === -1) {
        return;
      }
      tempSelected.splice(index, 1);
      if (!selected.length) {
        setDisabled(true);
      }
    } else {
      tempSelected.push(value);
    }
    setSelected(tempSelected);
    onValuesChange([], form.getFieldsValue(), tempSelected);
  };

  const onClickContinue = async () => {
    const formValues = form.getFieldsValue();
    const { trackingNumber, carrier } = formValues;
    const items = [];

    unFulfilledItems.forEach((item, index) => {
      if (selected.includes(`${item.lineItemId}__0__${index}`)) {
        items.push({
          lineItemId: item.lineItemId,

        });
      }
    });
    const params = {
      policyId,
      items,
      trackingNumber,
      carrier,
    };
    try {
      const { code } = await fulfilledTracking(params);
      if (code === 0) {
        // await getPackageData({ policyId, issueType: type }, dispatch, navigate);
        navigate('../success');
      } else {
        message.error('Something went error, please try again');
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getUnfulfilledBlock = () => {
    if (!unFulfilledItems?.length) {
      return null;
    }
    return (
      <Panel icon={UnfulfilledTitle} title="Unfulfilled" className={classes.unful_panel}>
        {unFulfilledItems.map((item, index) => (
          <CheckBoxItem
            packageIndex="0"
            key={item.lineItemId}
            item={item}
            index={index}
            handleChange={handleChange}
            selectedItems={selected}
          />
        ))}
      </Panel>
    );
  };

  return (
    <section className={classes.content}>
      <PageTitle title="Fulfill item(s)" />

      <MessageTips
        message="Your order has not been fulfilled yet. If any items have already been shipped, please provide updated information regarding their actual shipping number."
      />
      <Form
        name="trackingForm"
        layout="vertical"
        onValuesChange={onValuesChange}
        className={classes.trackingForm}
        form={form}
      >
        {getUnfulfilledBlock()}
        <Panel>
          <div className={classes.track_tips}>Please provide the tracking information of your order.</div>
          <div className={classes.track_wrapper}>
            <TrackingFormItem form={form} />

          </div>
        </Panel>

        {/* <Button type="primary" disabled={disabled} htmlType="submit" className={classes.tracking_button}>Submit</Button> */}
        <BottomButtons
          // onClickBack={clearItems}
          isContinueDisabled={disabled}
          onClickContinue={onClickContinue}
        />
      </Form>

    </section>
  );
};
